var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m56.9 2.6.2-2.3 3-.3-.8 10L41 11.5l.8-10 3-.2-.1 2.3 4.6-.4.2-2.3 3-.3-.1 2.4 4.6-.4Zm-8 3.7-4.6.4v1.5l4.5-.4zM52 6v1.6l4.6-.4.1-1.6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.9 1.7 38 .2l-3 .3-1 10.7 3.1-.2.5-6.2 2.3-.2.3-3zm-14 11.9-3 .2-.6 6.2 16.2-1.3.2-3.1-13 1zm.4-4.6 8.4-.7-.2 3-11.6 1 1-10.8 11.5-1-.3 3.2-8.4.7zm16.2 7.2 7.7-.7-.3 3.9 3-.3.4-3.8 7.6-.7.3-3L40.7 13l-.2 3Zm43-2.4 13.8-1.2v.8l-13.9 1.2-.5 5.3 17-1.4.2-2.3-13.9 1.2v-.8l14-1.2.4-5.3-17 1.4zM101.4 0l-.6 7h.8l-.2 2.2L83 10.8l.2-2.3 14.7-1.3V5.7L84 7l.2-2.3 13.9-1.2v-.8L84.3 3.8l.2-2.3 17-1.4ZM15.8.3l-1.5 18.4 3-.2L19 0l-3 .3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m11.1 2.2.1-1.6 3.1-.2-1.5 18.4-3.1.3.6-7.7-2.3.2-.6 7.7-3 .3L5.5 4.2l-5.4.4.3-3L8.9.7l-.1 1.6 2.3-.2ZM8.3 8.5l2.3-.2.2-3-2.3.1z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m66.2 1.3-3.1.2L61.6 20l3-.3L65.8 6l3-.3-1 13.9 3-.3 1.4-16.9-6.2.5.2-1.5Zm12.1.5.2-1.5 3-.3L80 18.5l-3 .2.6-7.7-4.6.4.2-3 4.6-.5.3-3-4.6.4.2-3.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m118.7 12.6-12.3 1 .1-1.5-3 .2-.7 7.7 18.5-1.5.6-7.7-3 .2zm-12.6 4.8.1-1.5 12.3-1-.1 1.5z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m119.6 1.8.1-1.5 3.1-.3-.8 10-3.1.3.4-5.4-2.3.2-.1 1.5-10 .8-.1 1.6 10-.9-.2 2.3-13 1.1.4-6.1 10.8-1 .1-1.4-10.8.8.2-2.3 13.1-1-.1 1.5z"
  })));
};
export default SvgLogo;